module.exports = __webpack_public_path__ + "static/media/nutricia-brand-allergens-moluscs.a11f32e9.svg";